import axios from "@/common/http";

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    // 任务历史
    async recordList({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/fashionlabs/task/list", data);
      return res;
    },
    // 商品任务历史
    async commodityTaskList({ commit }, data) {
      console.log(commit);
      const res = await axios.post(
        "v1/stablediffusion/commodity_task_list",
        data
      );
      return res;
    },
    // 任务删除
    async recordDelete({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/fashionlabs/task/delete", data);
      return res;
    },
    // 满意度
    async recordSatisfaction({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/fashionclothing/satisfaction", data);
      return res;
    },
  },
  getters: {},
};
